import React, { useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import Formatter from '../components/Formatter'

import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItem,
  ListItemText,
  Divider,
  Tabs,
  Tab,
  useMediaQuery,
  useTheme,
  TextField,
  Button,
  IconButton,
  Tooltip
} from '@mui/material'

import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'

import { useSelector, useDispatch } from 'react-redux'
import { getSongs, searchSongs, getSong } from '../actions/songActions'
import { getPlaylist, getPublicPlaylists, deletePlaylist } from '../actions/playlistActions'

const Home = () => {
  const [tabValue, setTabValue] = useState(0)
  const [searchValue, setSearchValue] = useState('')
  const theme = useTheme()
  const { id, playlistId, songId } = useParams()
  const matches = useMediaQuery(theme.breakpoints.up('md'))
  const belowLg = useMediaQuery(theme.breakpoints.down('lg'))
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  // const scrollRef = useRef()
  const { songs, searchedSongs, song } = useSelector(state => state.songState)
  const { playlists, playlist } = useSelector(state => state.playlistState)
  const { userInfo } = useSelector(state => state.userState)

  // useEffect(() => {


  //   if (scrollRef.current && songs) {
  //     if (song) {
  //       const findSong = songs.find(search => search._id === song._id)
  //       scrollRef.current.scrollTop = songs.indexOf(findSong) * 50
  //     }
  //   }
  // }, [scrollRef.current, songs, song])

  useEffect(() => {
    if (matches && !playlistId) {
      dispatch(getSongs())
      dispatch(getPublicPlaylists())
    }
  }, [matches, location])

  useEffect(() => {
    if (id) {
      dispatch(getSong(id))
    }
  }, [id, location])

  useEffect(() => {
    if (songId) {
      dispatch(getSong(songId))
    }
  }, [songId, location])

  useEffect(() => {
    if (playlistId) {
      dispatch(getPlaylist(playlistId))
    }
  }, [playlistId, location])

  const changeTab = (event, newValue) => {
    setTabValue(newValue)
  }

  const submitSearchForm = e => {
    e.preventDefault()
    dispatch(searchSongs(searchValue))
  }

  return (
    <Box sx={{ display: 'flex' }}>
      {matches && <Box backgroundColor='#fff' sx={{ borderRight: 1, borderColor: 'divider', height: '93vh', width: belowLg ? 400 : 375, mr: 5, overflowY: 'auto' }}>
        {!playlistId ? <>
          <Tabs sx={{ mt: 5 }} value={tabValue} onChange={changeTab} centered>
            <Tab label='Songs' />
            <Tab label='Playlists' />
            <Tab label='Search' />
          </Tabs>
          {tabValue === 0 && <List sx={{ mt: 5 }}>
            <Divider />
            {songs && songs.map((song, index) => (
              <Link style={{ textDecoration: 'none', color: 'inherit' }} to={`/song/${song._id}`} key={song._id}>
                <ListItem disablePadding>
                  <ListItemButton selected={id === song._id} sx={{ px: 2, py: 3 }}>
                    <Typography variant='h6' sx={{ fontWeight: 400, fontSize: 20 }}>{index + 1}. {song.title}</Typography>
                  </ListItemButton>
                </ListItem>
                <Divider />
              </Link>
            ))}
          </List>}

          {tabValue === 1 && <List sx={{ mt: 5 }}>
            <Divider />
            {playlists && playlists.map(playlist => (
              <Link style={{ textDecoration: 'none', color: 'inherit' }} to={`/playlists/${playlist._id}`} key={playlist._id}>
                <ListItem disablePadding>
                  <ListItemButton sx={{ p: 2 }}>
                    <ListItemText secondary={playlist.songs.length + ` ${playlist.songs.length === 1 ? 'song' : 'songs'}`} primary={playlist.title} />
                  </ListItemButton>
                </ListItem>
                <Divider />
              </Link>
            ))}
          </List>}

          {tabValue === 2 && <Box sx={{ p: 2 }}>
            <Divider sx={{ mb: 1, mt: 3 }} />
            <form onSubmit={submitSearchForm}>
              <TextField
                label='Search'
                fullWidth
                sx={{ my: 2 }}
                value={searchValue}
                onChange={e => setSearchValue(e.target.value)}
              />
              <Button variant='contained' fullWidth type='submit' disabled={searchValue.length === 0}>Search</Button>
            </form>
            <Box sx={{ mt: 5 }}>
              {searchedSongs && <Typography color='textSecondary' sx={{ mb: 2 }}>{searchedSongs.length} {searchedSongs.length === 1 ? 'song' : 'songs'} found</Typography>}
              <Divider />
              {searchedSongs && searchedSongs.map(song => (
                <Link style={{ textDecoration: 'none', color: 'inherit' }} to={`/song/${song._id}`} key={song._id}>
                  <ListItem disablePadding>
                    <ListItemButton selected={id === song._id} sx={{ px: 2, py: 3 }}>
                      <Typography variant='h6' sx={{ fontWeight: 400, fontSize: 20 }}>{song.title}</Typography>
                    </ListItemButton>
                  </ListItem>
                  <Divider />
                </Link>
              ))}
            </Box>
          </Box>}
        </> : <>
          {playlist && <Box>
            <Box sx={{ mt: 4, mb: 2, px: 2, display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'space-between' }}>
              <ListItemText secondary={`Created by ${playlist.user.name}`}>
                <Typography variant='h6'>{playlist.title}</Typography>
              </ListItemText>
              {userInfo && (userInfo.role === 'admin' || userInfo.role === 'superadmin' || playlist.user._id === userInfo._id) && <Box>
                <Link style={{ textDecoration: 'none', color: 'inherit' }} to={`/edit/playlists/${playlist._id}`}>
                  <Tooltip title='Edit'>
                    <IconButton>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                </Link>
                <Tooltip title='Delete'>
                  <IconButton onClick={() => dispatch(deletePlaylist(playlist._id, navigate))}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Box>}
            </Box>
            <Divider />
            {playlist.songs.map(song => (
              <Link style={{ textDecoration: 'none', color: 'inherit' }} to={`/playlists/${playlistId}/${song.song._id}`} key={song.song._id}>
                <ListItem disablePadding>
                  <ListItemButton selected={songId === song.song._id} sx={{ px: 2, py: 3 }}>
                    <Typography variant='h6' sx={{ fontWeight: 400, fontSize: 20 }}>{song.song.title}</Typography>
                  </ListItemButton>
                </ListItem>
                <Divider />
              </Link>
            ))}
          </Box>}
        </>}
      </Box>}
      {!id && !playlistId && <Box sx={{ width: 1200, mt: matches ? 15 : 7, height: 'fit-content', mx: matches ? 'auto' : 0 }}>
        <Typography gutterBottom variant={matches ? 'h3' : 'h4'} align='center'>Welcome to Eclesia Songs</Typography>
        <Typography align='center' gutterBottom variant='h6' sx={{ fontWeight: 400, my: 2, maxWidth: 450, mx: 'auto' }}>Bine ați venit la Eclesia Songs!</Typography>
        <Typography align='center' variant='h6' sx={{ fontWeight: 400 }}>
          Pentru a utiliza aplicația puteți să apasați cele trei linii din colțul stânga sus.<br />
          Administratorii pot adăuga, crea și sa șteargă cântece.<br />
          De asemenea ei pot să și adauge playlist-uri publice.<br />
          Pentru a le vizualiza, apăsați pe secțiune "Playlists" din sidebar.
        </Typography>
      </Box>}
      {song && id && <Box sx={{ px: 2, flexGrow: 2 }}>
        <Formatter song={song} />
      </Box>}
      {playlistId && songId && song && <Box sx={{ px: 2, flexGrow: 2 }}>
        <Formatter song={song} />
      </Box>}
    </Box>
  )
}

export default Home
